<template>
    <div class="detail-info-header">
        <div v-if="!isMobileSize" class="pc">
            <div class="price-caculator">
                <price class="price" />
                <caculator v-if="!hideCalculator" class="caculator" />
                <tour-button class="button" />
            </div>
            <div
                v-if="infoFlag.tag || infoFlag.exclusiveTag"
                class="house-status-container"
            >
                <house-tag
                    v-bind="infoFlag.exclusiveTag"
                    v-if="infoFlag.exclusiveTag"
                    theme="v3"
                />
                <house-tag
                    v-bind="infoFlag.tag"
                    v-if="infoFlag.tag"
                    theme="v3"
                />
            </div>
            <Addr tag="h1" class="address" />
            <count class="count" />
            <hr class="line" />
        </div>
        <div v-else class="mobile">
            <price class="price" />
            <caculator v-if="!hideCalculator" class="caculator" />
            <div
                v-if="infoFlag.show && infoFlag.text"
                class="house-status"
                :class="infoFlag.className"
            >
                {{ infoFlag.text }}
            </div>
            <tour-button class="button" />
            <house-tag theme="v3" v-if="infoFlag.tag" v-bind="infoFlag.tag" />
            <Addr tag="h1" class="address" />
            <count class="count" />
        </div>
    </div>
</template>

<script>
import { mapState as rootMapState } from 'pinia';
import { mapState } from '@/store/helpers';
import { usePageStore } from '@/store';
import price from './price.vue';
import caculator from './caculator.vue';
import count from './count.vue';
import TourButton from './tour-button.vue';
import Addr from '../../_components/address.vue';
import houseTag from '@/modules/md-house/_component/house-tag';
export default {
    inject: ['onFavoriteClick', 'openCaculator'],
    components: {
        price,
        count,
        caculator,
        TourButton,
        Addr,
        houseTag
    },
    data: function() {
        return {};
    },
    created() {},
    computed: {
        ...rootMapState(usePageStore, {
            'house': store => store.page?.house || {}
        }),
        ...mapState({
            'listingDetail': store => store.listingDetail,
            'hasFavor': store => store.hasFavor,
            'pricePerMonth': store => store.pricePerMonth,
            'infoFlag': store => store.infoFlag
        }),
        isMobileSize() {
            return this.platform.isMobile;
        },
        info() {
            return this.listingDetail.info || {};
        },
        soldFlag() {
            if (this.info.listingStatus == 'Sold') {
                return 'sold-detail';
            }
            return '';
        },
        showListingPrice() {
            return (
                this.house.showListingPrice && this.info.listingStatus == 'Sold'
            );
        },
        trend() {
            return (
                (
                    (Math.abs(this.info.soldPrice - this.info.price) /
                        this.info.price) *
                    100
                ).toFixed(1) + '%'
            );
        },
        hideCalculator() {
            return (
                this.info.purchaseType == 'For Rent' ||
                this.info.statusOrigin == 'Leased'
            );
        }
    }
};
</script>
<style lang="scss">
@import '../../../../theme/mixin.scss';
@import '../../../../theme/media.scss';
@mixin calc-box {
    .icon-caculator {
        position: relative;
        top: -1px;
        color: #202437;
        &:before {
            color: #202437;
            cursor: pointer;
        }
        &.nodisclosure {
            opacity: 0.4;
            &:before {
                cursor: initial;
            }
        }
        .payment-text {
            font-size: 12px;
            color: var(--color-disable);
            margin-left: 5px;
            margin-right: 8px;
        }
    }
}
.md-detail-info.standard {
    .detail-info-header {
        .pc {
            .price-caculator {
                color: var(--color-label);
                padding-bottom: 6px;
                display: flex;
                position: relative;
                .caculator {
                    height: 30px;
                    line-height: 30px;
                    margin-left: 25px;
                }
                .button {
                    width: 30%;
                    position: absolute;
                    top: 0;
                    right: 0;
                }
            }
            .house-status-container {
                margin-top: 9px;
            }
            .address {
                margin-top: 15px;
            }
            .line {
                height: 1px;
                border: none;
                border-top: 1px solid #e5e8f1;
                margin: 30px 0;
            }
            .count {
                margin-top: 25px;
            }
        }
        .mobile {
            display: none;
        }
    }
    @media (max-width: 600px) {
        .detail-info-header {
            position: relative;
            .pc {
                display: none;
            }
            .mobile {
                display: block;
                .price {
                    width: 70%;
                    margin: 0;
                }
                .caculator {
                    font-size: 14px;
                    margin-top: 10px;
                }
                .button {
                    width: 30%;
                    position: absolute;
                    top: 0;
                    right: 0;
                    display: flex;
                    .save {
                        display: none;
                    }
                    .btn-item {
                        margin-left: 0;
                    }
                }
                .address {
                    display: block;
                    width: 100%;
                    margin-top: 20px;
                }
                .count {
                    margin-top: 20px;
                }
                .house-status {
                    margin-top: 10px;
                }
            }
        }
    }
}
</style>
